export default __webpack_public_path__ + "static/media/bills.65bb8ab3.svg";